import {FETCH_DEPARTMENTS} from '../actions/department';

export default function(state = [], action){

    switch(action.type){

        // case ADD_CATEGORY:
        //     // let newState = [...state];
        //     // let objIndex = newState.findIndex((obj => obj.key == action.payload.key));
        //     // newState.splice(objIndex, 1, action.payload);
        //     // return newState;

        case FETCH_DEPARTMENTS:
            return action.payload;
    }

    return state;
}